'use client';

import React from 'react';
import { useI18n } from '@/i18n/LocaleProvider';

export default function StoreSection() {
  const { t } = useI18n();

  return (
    <section id="store" className="pb-20 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto scroll-mt-32">
      <div className="relative glass-card rounded-3xl border border-border border-top-glow border-top-glow-gold overflow-hidden p-8 md:p-12">
        <div className="absolute -top-24 -right-24 w-72 h-72 blob-accent opacity-40 pointer-events-none" />
        <div className="relative">
          <span className="inline-flex items-center gap-2 text-xs font-bold tracking-widest uppercase text-accent mb-3">
            <span className="w-2 h-2 rounded-full bg-accent animate-pulse-glow" />
            {t.store.eyebrow}
          </span>
          <h2 className="text-3xl md:text-4xl font-extrabold tracking-tight text-foreground mb-3 leading-tight">{t.store.title}</h2>
          <p className="text-muted-foreground leading-relaxed max-w-2xl mb-8">{t.store.body}</p>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 max-w-3xl mb-6">
            {t.store.points.map((point) => (
              <div key={point.title} className="rounded-2xl bg-muted/40 border border-border p-5">
                <p className="text-sm font-bold text-foreground mb-1">{point.title}</p>
                <p className="text-sm text-muted-foreground leading-relaxed">{point.body}</p>
              </div>
            ))}
          </div>
          <p className="text-sm text-muted-foreground">{t.store.more}</p>
        </div>
      </div>
    </section>
  );
}
